import Vue from 'vue';
import feathersClient from '../../feathers-client';
const defaultTrustRolePagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultTrustRoleFilter = {
	$skip:defaultTrustRolePagination.$skip,
	$limit: defaultTrustRolePagination.$limit
};
export default {
	state: {
		permissions: [],
		trustRole:[],
		trustRolePermission:[],
		trustRolePagination:defaultTrustRolePagination,
		TrustRoleFilter:defaultTrustRoleFilter,
		activeTrustRoles:[],
		GroupFeaturePermission:[],
	},
	getters: {
		permissions: (state) => state.permissions,
		settrustRolePage:(state) => {
			const {$limit, $skip} = state.trustRolePagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_PERMISSIONS: (state, permissions) => {
			state.permissions = permissions;
		},
		SET_GROUP_FEATURE_PERMISSION:(state,data) => {state.GroupFeaturePermission = data;},
		SET_TRUST_ROLE:(state,data) => {state.trustRole = data;},
		SET_TRUST_ROLE_PAGINATION:(state, data) => {state.trustRolePagination = {...state.trustRolePagination, ...data};},
		SET_TRUST_ROLE_FILTER: (state, filter) => { state.TrustRoleFilter = { ...state.TrustRoleFilter, ...filter }; },
		SET_TRUST_ROLE_PERMISSION: (state, trustRolePermission) => { state.trustRolePermission = trustRolePermission; },
		SET_ACTIVE_TRUST_ROLES:(state,data) => {state.activeTrustRoles = data},
	},
	actions: {
		setTrustRoleFilter: ({ commit }, filter) => {
			commit('SET_TRUST_ROLE_FILTER', filter);
		},
		settrustRoleListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.trustRolePagination.$limit;
			commit('SET_TRUST_ROLE_PAGINATION', { $skip });
			commit('SET_TRUST_ROLE_FILTER', { $skip });
		},

		loadPermissions: async ({ commit,rootGetters },query) => {
			const results = await feathersClient.service('api/v3/get-all-permissions').find({
				query: {
					$role:rootGetters.currentUserRole,
					// roleLevel:'ADMIN',
					...query,
					$paginate: false
				},
			});
			commit('SET_PERMISSIONS', results);
			return results;
		},
		loadTrustRolePermission: async ({ commit,rootGetters }, query) => {
			const url = 'api/v3/get-all-permissions'
			const results = await feathersClient.service(url).find({
				query:{
					$role: rootGetters.currentUserRole,
					...query,
					$paginate:false,
				}
			});
			commit('SET_TRUST_ROLE_PERMISSION', results);
		},
		getPermissions: async ({ commit,rootGetters },query) => {
			const results = await feathersClient.service('api/v3/get-all-permissions').find({
				query: {
					$role:rootGetters.currentUserRole,
					roleLevel:'ADMIN',
					...query,
					$paginate: false
				},
			});
			commit('SET_PERMISSIONS', results);
			return results;
		},

		getAllTrustRoleForTrust: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/trust-roles').find({
				query:{
					$role:rootGetters.currentUserRole,
					fields: ['permissions','role'],
					...filter,

				}
			});
			commit('SET_TRUST_ROLE',results.data);
			commit('SET_TRUST_ROLE_PAGINATION', {total :results.total})
			return results.data;
		},
		getRolePermissionById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/trust-roles').get(id,{
				query:{
					fields:['permissions','role'],
				}
			});

			return results
		},
		createRolePermissions: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/trust-roles').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateRolePermissions: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/trust-roles').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
					$isUpdateRolePermissions:true
				}
			});
			return results;
		},
		updateIsActiveRolePermissions: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/trust-roles').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
					$isUpdateActive:true
				}
			});
			return results;
		},

		deleteRolePermissions: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/trust-roles').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getAllRolesForTrust: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/trust-roles').find({
				query:{
					$role:rootGetters.currentUserRole,
					fields: ['role'],
					$paginate:false,
					isActive:true,
					...filter,

				}
			});
			commit('SET_ACTIVE_TRUST_ROLES',results)
			return results;
		},
		getGroupFeaturePermission: async({rootGetters,commit},query) => {
			const results = await feathersClient.service('/api/v3/get-all-feature-permissions').find({
				query: {
					$role:rootGetters.currentUserRole,
					// roleLevel:'ADMIN',
					...query,
					$paginate: false
				},
			});
			commit('SET_GROUP_FEATURE_PERMISSION',results);
			return results;
		},

	}
};
